<template>
  <span>
    <span v-if="typeof document !== 'undefined'">
      <span v-if="!present">
        <i :class="['text-' + status.color, 'fa', status.icon]"></i>
          <source-app :name="document.source" size="tiny"></source-app>
        <a :href="document.file_url">
          {{ document.file_name }}
        </a>
        {{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(document.amount_total) }}
      </span>
    </span>
    <span v-else>
      <pulse-loader color="#cccccc" size="8px"></pulse-loader>
    </span>
  </span>
</template>

<script>
  import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
  import SourceApp from './SourceApp.vue'

  export default {
    name: 'document',
    components: {
      SourceApp,
      PulseLoader
    },
    props: ['present', 'item'],
    computed: {
      document () {
        return this.item
      },
      status () {
        return this.$model.document.getStatus(this.document)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Document.vue?23e29631